import React, { useReducer, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import CustomAlert from '../../componentes/alerts/CustomAlert';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Grid, Button, Typography, responsiveFontSizes } from '@material-ui/core';
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from '../../componentes/autocomplete/DefaultAutocomplete';
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import LabelSuccess from '../../componentes/labels/LabelSuccess';
import LabelError from '../../componentes/labels/LabelError';
import { DefaultDatagrid } from '../../componentes/datagrid/DefaultDatagrid';
import errorConsultService from "./ErrorConsultService";
import CustomDatePicker from "../../componentes/form-fields/DatePicker/CustomDatePicker";
import {
    FaHome,
    FaLink,
    FaUnlink
} from "react-icons/fa";
import InputField from "../../componentes/form-fields/InputField/InputField";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import DefaultChip from '../../componentes/chip/DefaultChip';

export default function ErrorConsult() {
    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");
    const loggedUserIdRole = sessionStorage.getItem("role");

    const initialScreenErrorState = {
        errorCode: '',
        user: 0,
        startDate: new Date(),
        endDate: new Date(),
        userId: userId,
        warningScreenError: false,
        warningMessage: '',
    };

    const cleanScreenErrorState = {
        errorCode: '',
        user: 0,
        startDate: null,
        endDate: null,
        userId: userId,
        warningScreenError: false,
        warningMessage: '',
    };

    const [screenError, setScreenError] = useState(initialScreenErrorState);

    const { errorCode, user, startDate, endDate, warningScreenError, warningMessage } = screenError

    const [clearedScreenError, setClearedScreenError] = useState(false);
    const [screenErrorRows, setScreenErrorRows] = useState([]);
    const [message, setMessage] = useState("");
    const [error, setError] = useState(warningScreenError);
    const [success, setSuccess] = useState(false);

    const columnsScreenError = (t) => [
        {
            field: "errorCode",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="errorCode" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="primary"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.errorCode}
                            </Typography>}
                        />
                    </>
                )
            }
            
        },
        {
            field: "description",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="description" name="description" />;
            },
        },
        {
            field: "origin",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="origin" name="status" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="grey"
                            color="white"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.origin}
                            </Typography>}
                        />
                    </>
                )
            }
        },
        {
            field: "dtError",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="status" name="status" />;
            },
            template: (props) => {
                return (
                            <>
                                {props.status === 0 ? (
                                    <IconSwitch name="canceled" />
                                ) : (
                                    <IconSwitch name="active" />
                                )}
                            </>
                        );
            },
        },
        {
            field: "userReturn",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="user" name="user" />;
            },
            template: (props) => {
            return (
                <>
                    {props.userReturn ? 
                        <DefaultChip
                            style="grey"
                            color="white"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.userReturn}
                            </Typography>}
                        />
                    : null}
                </>
            )
        }
        },
    ];


    const handleChange = (event) => {
        const { name, value } = event.target;
        setScreenError({ ...screenError, [name]: value });
    };

    const handleCloseAlertScreenError = () => {
        setScreenError({ ...screenError, warningScreenError: false });
    };

    const handleClearScreenError = () => {
        setClearedScreenError(!clearedScreenError);
        setScreenError(cleanScreenErrorState);
        setScreenErrorRows([]);
    };

    const handleSearchScreenError = () => {
        if (screenError.errorCode === ''){
            screenError.errorCode = 0;
        }
        if (screenError.startDate === null){
            screenError.startDate = '';
        }
        if (screenError.endDate === null){
            screenError.endDate = '';
        }
        let request = { ...screenError }
        
        errorConsultService
            .get(request)
            .then((response) => {
                if (response.data !== 'Nenhum erro encontrado para os filtros informados!'){
                    setScreenErrorRows(response.data)
                }
                else{
                    setScreenErrorRows([]);
                }
                    
            })
            .catch((e) => {
            });

            if (screenError.errorCode === 0){
                screenError.errorCode = '';
            }
            
        
    };

    const handleWarningScreenError = () => {
        setScreenErrorRows([]);
    };

    const handleClickGrid = (rowData) => {
        setMessage("");
        setSuccess(false);

        setScreenError({
            id: rowData.id
            , description: rowData.description
            , status: rowData.status
        })
    }

    useEffect(() => {
        handleSearchScreenError();
    }, [screenError.errorCode]);

    return (
        <>
            <DefaultScreenAccordion
                isConsult
                title="Pesquisar erros do aplicativo"
                fields={
                    <>
                        <GridItemContainer>
                            <CustomAlert
                                success={success}
                                message={message}
                                warning={warningScreenError}
                                handleCloseAlert={handleCloseAlertScreenError}
                                snackbar
                                autoClose
                            />
                            <GridInputRow>
                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="errorCode"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={errorCode}
                                        length={50}
                                        error={warningScreenError && errorCode === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"user"}
                                        onChange={handleChange}
                                        value={user}
                                        label={t("user")}
                                        defaultSize
                                        useApi
                                        endpoint='GetUserAutoComplete'
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <CustomDatePicker
                                        id="startDate"
                                        name="startDate"
                                        selectedDate={startDate}
                                        handleChange={handleChange}
                                        error={
                                            endDate !== null &&
                                            startDate > endDate
                                        }
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <CustomDatePicker
                                        id="endDate"
                                        name="endDate"
                                        selectedDate={endDate}
                                        handleChange={handleChange}
                                        error={
                                            endDate !== null &&
                                            startDate > endDate
                                        }
                                    />

                                </Grid>
                            </GridInputRow>
                            {<SearchClearSaveRow
                                onClickClear={handleClearScreenError}
                                onClickSearch={handleSearchScreenError}
                            />}

                        </GridItemContainer>
                    </>
                }
            />
            {screenErrorRows.length > 0 ? (
                <DefaultScreenAccordion

                    fields={
                        <DefaultDatagrid
                            columns={columnsScreenError(t, handleSearchScreenError)}
                            dataSource={screenErrorRows}
                            cellSelected={(args, grid) => handleClickGrid(args.data)}
                            allowPaging={true}
                        />
                    } />
            ) : null}
        </>
    );
};
